const getVisibleCards = (scroller) =>
  [...scroller.querySelectorAll('[data-card]')].filter((card) => !card.hidden);

const isTouch = () =>
  'ontouchstart' in window ||
  (navigator.maxTouchPoints || 0) > 0 ||
  (navigator.msMaxTouchPoints || 0) > 0;

const updateAllControlsVisibility = () => {
  document.querySelectorAll('[data-cards-scroller]').forEach((scroller) => {
    const id = scroller.getAttribute('data-cards-scroller');
    if (!id) return;
    const controls = document.querySelector(
      `[data-cards-scroller-controls="${id}"]`
    );

    if (!controls) return;

    const hasOverflowX = scroller.scrollWidth - scroller.clientWidth > 1;
    const show = hasOverflowX && !isTouch();
    controls.style.display = show ? '' : 'none';
  });
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cards-scroller]').forEach((scroller) => {
    scroller.addEventListener('scroll', () => {
      const isAtEnd =
        scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth;
      scroller.style.setProperty(
        '--card-scroller-can-scroll-right',
        isAtEnd ? '0' : '1'
      );
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  let scrollerPositions = {};
  const scrollerItems = {};

  const updateNavButtons = (scroller) => {
    const id = scroller.getAttribute('data-cards-scroller');
    const nextBtn = document.querySelector(
      `[data-controls="${id}"][data-cards-scroller-btn="next"]`
    );
    const prevBtn = document.querySelector(
      `[data-controls="${id}"][data-cards-scroller-btn="prev"]`
    );

    const isAtStart = scroller.scrollLeft <= 0;
    const isAtEnd =
      Math.ceil(scroller.scrollLeft + scroller.clientWidth) >=
      scroller.scrollWidth;

    if (nextBtn) nextBtn.disabled = isAtEnd;
    if (prevBtn) prevBtn.disabled = isAtStart;
  };

  document.querySelectorAll('[data-cards-scroller-btn]').forEach((el) => {
    el.addEventListener('click', () => {
      const id = el.getAttribute('data-controls');
      const action = el.getAttribute('data-cards-scroller-btn');
      const scroller = document.querySelector(`[data-cards-scroller="${id}"]`);
      const items = getVisibleCards(scroller);
      const itemsCount = items.length;

      console.log(id);
      console.log(action);

      if (!itemsCount) return;

      // get all item positions
      if (typeof scrollerPositions[id] === 'undefined') {
        scrollerPositions[id] = [];
        items.forEach((item) => {
          scrollerPositions[id].push(
            Math.round(
              item.getBoundingClientRect().left -
                scroller.getBoundingClientRect().left
            )
          );
        });
      }

      // define the current item
      if (typeof scrollerItems[id] === 'undefined') {
        scrollerItems[id] = 0;
      }

      // compare the scroll position to the item position
      for (let i = scrollerPositions[id].length - 1; i >= 0; i--) {
        if (
          scrollerPositions[id][i] + 5 >=
          parseFloat(scroller.getAttribute('data-scrollLeft'))
        ) {
          scrollerItems[id] = i;
        }
      }

      // next or prev item
      if (action === 'next') {
        scrollerItems[id]++;
        if (scrollerItems[id] >= itemsCount) {
          scrollerItems[id] = 0;
        }
      } else {
        scrollerItems[id]--;
        console.log(scrollerItems[id]);
        if (scrollerItems[id] < 0) {
          scrollerItems[id] = itemsCount - 1;
        }
      }

      // scroll to the new current item
      const item = items[scrollerItems[id]];
      scroller.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      return false;
    });
  });

  // update the scroll position on each scroller so it's easy to access
  document.querySelectorAll('[data-cards-scroller]').forEach((el) => {
    el.setAttribute('data-scrollLeft', 0);

    el.addEventListener(
      'scroll',
      () => {
        el.setAttribute('data-scrollLeft', el.scrollLeft);
        updateNavButtons(el);
      },
      { passive: true }
    );

    el.addEventListener('cardscroller:refresh', () => {
      const id = el.getAttribute('data-cards-scroller');
      delete scrollerPositions[id];
      scrollerItems[id] = 0;
      el.setAttribute('data-scrollLeft', 0);
      updateNavButtons(el);
      updateAllControlsVisibility();
    });
  });

  window.addEventListener('resize', function (e) {
    scrollerPositions = {};
  });
});

// Show .cards-scroll__controls only when there is horizontal overflow
// and the device is NOT touch-capable. Run on load and on resize.
updateAllControlsVisibility();
document.addEventListener('load', updateAllControlsVisibility);
window.addEventListener('resize', updateAllControlsVisibility);
